import ApplyMedicalsApp from './ApplyMedicalsApp';
import React from 'react';
import {Redirect} from 'react-router-dom';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const ApplyMedicalsAppConfig = {
    settings: {
        layout: {
            config: {
                footer: {
                    display: false
                }
            }
        }
    },
    auth: authRoles.medical,//  ['medical']
    routes: [
        {
            path: '/apps/applyMedical/:id',
            component: ApplyMedicalsApp
        },
        {
            path: '/apps/applyMedical',
            component: () => <Redirect to="/apps/applyMedical/all"/>
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/medical/ApplyMedicalsAppConfig.js